import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import {
  ButtonComponent,
  ButtonOptions,
  DateComponent,
  DateOptions,
  FormComponent,
  ModalComponent,
  ModalOptions,
  SelectComponent,
  SelectOptions,
  TableComponent,
} from '@shared/components';
import { DropdownComponent, DropdownOptions } from '@shared/components/dropdown/dropdown.component';
import { Coding } from '@core/classes/other/coding';
import { APIService, DataService, ToastService } from '@core/services';
import { PatientService } from '@core/services/patient.service';
import { Events } from '@core/interfaces';
import { FormGroup } from '@angular/forms';
import { HTTPMethods, ModalTypes } from '@core/enums';
import { HttpHeaders } from '@angular/common/http';
import { DefaultSearchComponent } from '@shared/components/dropdown/search/default-search/default-search.component';
import { lastValueFrom } from 'rxjs';
import { Response } from '@core/classes/other/response';
import { Router } from '@angular/router';
import { AddAllergyComponent } from '@modules/cy/patient/ps/components/allergies/actions/add-allergy/add-allergy.component';
import { MedicalDevice } from '@core/classes/tables/medical-device';

@Component({
  selector: 'ncp-allergy-unknown-values',
  imports: [SelectComponent],
  templateUrl: './allergy-unknown-values.component.html',
  styleUrl: './allergy-unknown-values.component.scss',
})
export class AllergyUnknownValuesComponent implements OnInit {
  @ViewChild('select') select!: SelectComponent;
  protected readonly toastService = inject(ToastService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private apiService = inject(APIService);
  private patientService = inject(PatientService);
  private dataService = inject(DataService);
  protected readonly router = inject(Router);

  protected data = model<any>();
  protected unknownSelectOptions = signal<SelectOptions>({});

  protected form: FormGroup = new FormGroup({});

  protected _unknownValue?: number | string;

  get unknownValue() {
    return this._unknownValue;
  }

  set unknownValue(value: number | string | undefined) {
    this._unknownValue = value;
  }

  ngOnInit() {
    this.unknownSelectOptions.set(
      new SelectOptions({
        label: {
          text: 'information_allergies',
          class: 'm-0 me-2',
        },
        values: [
          { id: 0, value: 'has_allergies' },
          { id: 1, value: 'no_info_allergies' },
          { id: 2, value: 'no_known_allergies' },
        ],
        model: this.unknownValue,
        onModelChange: this.onUnknownValueChange,
        disabled:
          !(
            this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit'
          ) ||
          (this.data()?.tblOptions() &&
            this.data()?.tblOptions().data &&
            (this.data()?.tblOptions().data!.length || [].length) > 0),
      })
    );
    this.setInitialUnknownValue();
  }

  ngAfterViewInit(): void {}

  ngAfterContentInit(): void {}

  ngAfterContentChecked() {}

  ngAfterViewChecked() {}

  setInitialUnknownValue = () => {
    if (
      this.data().tblOptions() &&
      this.data()?.tblOptions().data &&
      this.data()?.tblOptions().data.length > 0 &&
      this.data()?.tblOptions().otherData &&
      this.data()?.tblOptions().otherData.length === 0
    ) {
      this.unknownValue = 0;
    } else {
      this.unknownValue =
        this.data().tblOptions() &&
        this.data()?.tblOptions().data &&
        this.data()?.tblOptions().data.length === 0 &&
        this.data()?.tblOptions().otherData &&
        this.data()?.tblOptions().otherData.length === 1
          ? this.data()?.tblOptions().otherData[0].coding_id
          : undefined;
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnDAOptions().disabled = true;
        this.data().extra.componentInstance.btnNDAOptions().disabled = true;
      }
    }
    this.unknownSelectOptions().model = this.unknownValue;
  };

  protected onUnknownValueChange = (value?: number | string) => {
    this.select.blur();
    if (value && value !== 0) {
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnDAOptions().isLoading = true;
        this.data().extra.componentInstance.btnNDAOptions().isLoading = true;
      }
      this.apiService
        .call({
          path: '/unknown-values',
          headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
          body: {
            status: 1,
            coding_id: value.toString(),
            epSOS_OID: '1.3.6.1.4.1.12559.11.10.1.3.1.42.47',
            version_id: this.patientService.patient?.version?.new || -1,
          },
        })
        ?.subscribe((res) => {
          if (res && res.status && res.status === 1) {
            if (this.data()?.extra?.componentInstance) {
              this.data().extra.componentInstance.btnDAOptions().disabled =
                value === 1 || value === 2;
              this.data().extra.componentInstance.btnDAOptions().isLoading = false;
              this.data().extra.componentInstance.btnNDAOptions().disabled =
                value === 1 || value === 2;
              this.data().extra.componentInstance.btnNDAOptions().isLoading = false;
            }
            this.data()?.tbl.detectChanges();
            this.unknownValue = value;
          }
        });
    } else {
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnDAOptions().disabled = false;
        this.data().extra.componentInstance.btnNDAOptions().disabled = false;
      }
      this.unknownValue = value;
    }
  };
}
